var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gradient-banner position-relative",staticStyle:{"padding":"6vh 0px"}},[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("member")))])]),_c('SponsorTree')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }